import React from 'react'
import { Icon, RowFlexDiv, SearchInput, ColumnFlexDiv } from '../CommonStyle'
import { useHistory } from 'react-router-dom'

import ZoomTab from '../../AssignmentsGalleryView/ZoomTab'
import { NudistaMedium16 } from '../Fonts'

const AssignmentHeader = ({
  calendarView = { calendarView },
  setCalendarView = { setCalendarView },
}) => {
  const history = useHistory()

  return (
    <RowFlexDiv minWidth='100%'>
      <RowFlexDiv gap='20px' alignSelf='flex-start'>
        <RowFlexDiv gap='5px'>
          <RowFlexDiv
            width='31px'
            height='31px'
            justifyContent='center'
            src='linear-gradient(180deg, #F19D4C 0%, #C16E97 52%, #8840E1 100%)'
            borderRadius='5px'
          >
            <Icon src='/images/mainView/assignmentsView/bxs-car.svg' />
          </RowFlexDiv>
          <NudistaMedium16 color='primary'>234 Miles</NudistaMedium16>
        </RowFlexDiv>
        <RowFlexDiv gap='5px'>
          <RowFlexDiv justifyContent='center'>
            <Icon src='/images/mainView/assignmentsView/assignment-o.png' />
          </RowFlexDiv>
          <NudistaMedium16 color='primary'>23 Assignments</NudistaMedium16>
        </RowFlexDiv>
      </RowFlexDiv>

      <ColumnFlexDiv alignItems='center' gap='30px'>
        <SearchInput
          minWidth='250px'
          icon='/images/navbar/search-icon.svg'
          placeholder='Search for Assignments, Contacts, etc…'
        />
        <RowFlexDiv width='250px'>
          <Icon src='/images/mainView/assignmentsView/arrow-left.svg' />
          <RowFlexDiv gap='5px'>
            <NudistaMedium16 color='primary'>FEBRUARY 2021</NudistaMedium16>
            <NudistaMedium16 color='secondary'>Week 1</NudistaMedium16>
          </RowFlexDiv>
          <Icon src='/images/mainView/assignmentsView/arrow-right.svg' />
        </RowFlexDiv>
      </ColumnFlexDiv>

      <ColumnFlexDiv gap='30px'>
        <RowFlexDiv gap='10px' alignSelf='flex-end'>
          <Icon
            src='/images/mainView/assignmentsView/map-view.svg'
            onClick={() => {
              history.push('/map-view')
            }}
          />
          <Icon
            src='/images/mainView/assignmentsView/calendar-view.svg'
            onClick={() => {
              history.push('/week-view')
            }}
          />
          <Icon src='/images/mainView/assignmentsView/Cloud download.png' />
        </RowFlexDiv>
        <RowFlexDiv width='180px' height='20px'>
          <ZoomTab zoomView={calendarView} setZoomView={setCalendarView} />
        </RowFlexDiv>
      </ColumnFlexDiv>
    </RowFlexDiv>
  )
}

export default AssignmentHeader
